// ===========================================================
// ERP ORDERS MODULE
// ===========================================================

function renderOrdersUI(){
  const target = document.getElementById('orders-target');
  if(!target) return;
  
  const all = UI_DATA.orders || [];
  const start = (CURRENT_PAGE.orders - 1) * PAGE_SIZE;
  const pageOrders = all.slice(start, start + PAGE_SIZE);
  
  target.innerHTML = `
    <div class="product-card">
      <div id="orders-table-container">
        <table class="enterprise-table">
          <thead>
            <tr>
              <th>Order</th>
              <th>Customer</th>
              <th>Phone</th>
              <th>Status</th>
              <th>Total (${SHOP_CURRENCY})</th>
            </tr>
          </thead>
          <tbody>
            ${pageOrders.map(o => `
              <tr>
                <td><b>${o.name}</b></td>
                <td>${o.customer?.first_name || 'Guest'} ${o.customer?.last_name || ''}</td>
                <td>${o.customer?.phone || 'N/A'}</td>
                <td>
                  <span style="
                    padding: 4px 8px;
                    border-radius: 4px;
                    font-size: 12px;
                    background: ${getOrderStatusColor(o.financial_status, o.fulfillment_status)};
                    color: white;
                  ">${o.financial_status || 'N/A'}</span>
                </td>
                <td><b>${formatPrice(o.total_price)}</b></td>
              </tr>`).join('')}
          </tbody>
        </table>
      </div>
      <div id="orders-pagination-holder"></div>
    </div>`;
  
  renderPaginationUI('orders', all.length, CURRENT_PAGE.orders);
}

// Helper for order status colors
function getOrderStatusColor(financial, fulfillment) {
  if (financial === 'paid' && fulfillment === 'fulfilled') return '#10b981';
  if (financial === 'paid') return '#3b82f6';
  if (financial === 'pending' || financial === 'authorized') return '#f59e0b';
  if (financial === 'refunded') return '#ef4444';
  return '#6b7280';
}

// Process Orders Search
window.processOrders = () => {
  const q = document.getElementById('ord-search')?.value.trim().toLowerCase() || '';
  
  UI_DATA.orders = MASTER_DB.orders.filter(o => {
    const matchOrder = o.name?.toLowerCase().includes(q);
    const matchEmail = o.email?.toLowerCase().includes(q);
    const matchCustomer = o.customer?.first_name?.toLowerCase().includes(q) || 
                          o.customer?.last_name?.toLowerCase().includes(q);
    return matchOrder || matchEmail || matchCustomer;
  });
  
  CURRENT_PAGE.orders = 1;
  renderOrdersUI();
};